import './index-metric-index.style.scss'

class indexMetricIndexController {

}

export default indexMetricIndexController;



// WEBPACK FOOTER //
// ./ui/src/components/index-metric-index/index-metric-index.controller.js